var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.href ? _setup.OzBaseButton : 'div',{tag:"component",class:[
    {
      relative: _vm.separator === _setup.OzListRowSeparator.Long || _vm.separator === _setup.OzListRowSeparator.FullWidth,
      flex: true,
      'items-center': true,
      'cursor-pointer': _vm.clickable,
      'mb-[calc(0.5em+1px)]': _setup.xSeparator,
      'after:left-0 after:right-0': _vm.separator === _setup.OzListRowSeparator.FullWidth,
      'after:left-1 after:right-1': _vm.separator === _setup.OzListRowSeparator.Long,
      'rounded-lg': true,
    },
    (_vm.separator === _setup.OzListRowSeparator.Long || _vm.separator === _setup.OzListRowSeparator.FullWidth) && _setup.lineSeparatorClass,
  ],attrs:{"href":_vm.href,"href-mode":_vm.hrefMode,"tabindex":_vm.clickable ? 0 : -1},on:{"click":function($event){return _vm.$emit('click')},"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter"))return null;return _vm.$emit('click')},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"space",32,$event.key,[" ","Spacebar"]))return null;return _vm.$emit('click')}]}},[_vm._t("left"),_vm._v(" "),_c('div',{class:[
      'flex',
      'flex-grow',
      'min-w-0',
      'items-center',
      'justify-between',
      _vm.separator === _setup.OzListRowSeparator.Short && ['relative', 'after:left-0 after:right-0', _setup.lineSeparatorClass],
    ]},[_vm._t("default"),_vm._v(" "),_vm._t("right")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }